import { Dispatch, SetStateAction, useEffect, useState } from 'react'

const originalTitle = document.title

export const useDocumentTitle = (title: string): [string, Dispatch<SetStateAction<string>>] => {
  const [documentTitle, setDocumentTitle] = useState(title)

  useEffect(() => {
    if (document.title !== documentTitle) document.title = documentTitle
    return () => {
      document.title = originalTitle
    }
  }, [documentTitle])

  return [documentTitle, setDocumentTitle]
}
